import React from 'react';

import './Footer.css';

function Index() {
  return <div className="footer">Made with 💙 in Florida </div>;
}

export default Index;
